import { render, staticRenderFns } from "./rp-chat.vue?vue&type=template&id=685dfa27&"
import script from "./rp-chat.vue?vue&type=script&lang=js&"
export * from "./rp-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports